export enum TravelPurpose {
  BUSINESS = 'Business',
  LEISURE = 'Leisure',
  OTHERS = 'Others'
}
